import { useQuery } from "@tanstack/react-query";
import axiosBaseURL from "..";
import { useAuth, AuthContextValue } from "../../providers/AuthProvider";

export const useGetAgronomyData = () => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["agronomy"],
    staleTime: 120,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/admin/agronomy`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
          // Authorization: authString,
        },
      });

      return result;
    },
  });
};

export const useGetAgroDealerDashboardValues = () => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["useGetAgroDealerDashboardValues"],
    staleTime: 120,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/dashboard/agrodeler`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};

export const useGetMFIDashboardValues = () => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["useGetMFIDashboardValues"],
    staleTime: 120,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/dashboard/bank`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};

export const usePullAgronomyData = () => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["latest agronomy"],
    staleTime: 120,
    enabled: false,
    retry: 1,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/admin/pullWeatherData`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
          // Authorization: authString,
        },
      });

      return result;
    },
  });
};
